import Header from "./components/Header";
import Footer from "./components/Footer";
import { Routes, Route, Navigate } from "react-router-dom";
import ContactPage from "./pages/ContactPage";
import HomePage from "./pages/HomePage";
import SuitePage from "./pages/SuitePage";
import ServicesPage from "./pages/ServicesPage";
import { MantineProvider } from "@mantine/core";
import "./App.css";

function App() {
  return (
    <MantineProvider>
      <div className="App">
        <Header />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/home" element={<HomePage />} />
          <Route path="contact" element={<ContactPage />} />
          {/* Practitioners page held back until real bios are ready; old links go home */}
          <Route path="practitioners" element={<Navigate to="/" replace />} />
          <Route path="suite" element={<SuitePage />} />
          <Route path="services" element={<ServicesPage />} />
        </Routes>
        <Footer />
      </div>
    </MantineProvider>
  );
}

export default App;
